const ITEMS = [
  "Pre-revenue — $0, stated plainly",
  "$1,000 founding pilot offer",
  "Patent pending",
  "Research published on Zenodo",
  "Founding pilots on active jobsites — next",
  "Abilene, TX",
  "No invented traction",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-slate-800 bg-[#0D1320] py-4"
      aria-hidden="true"
    >
      <div className="animate-ir-marquee flex w-max items-center gap-8 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
            {item}
            <span className="text-[#FF5500]">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
